<template>
  <div></div>
</template>

<script>
import { saveAs } from "file-saver";
import Docxtemplater from "docxtemplater";
import PizZip from "pizzip";
import PizZipUtils from "pizzip/utils/index.js";

export default {
  props: ["data", "url", "name", "gen"],
  data() {
    return {
      doc: null,
      content: null,
    };
  },
  watch: {
    async gen(newVal, oldVal) {
      if (newVal !== oldVal) {
        await this.printsDOCX();
      }
    },
  },
  methods: {
    // Promise-based loader instead of callback
    loadFile(url) {
      return new Promise((resolve, reject) => {
        PizZipUtils.getBinaryContent(url, (error, content) => {
          if (error) reject(error);
          else resolve(content);
        });
      });
    },

    // error replacer moved out as helper
    replaceErrors(key, value) {
      if (value instanceof Error) {
        return Object.getOwnPropertyNames(value).reduce((error, key) => {
          error[key] = value[key];
          return error;
        }, {});
      }
      return value;
    },

    async printsDOCX() {
      try {
        const content = await this.loadFile(this.url);

        const zip = new PizZip(content);
        const doc = new Docxtemplater(zip, {
          paragraphLoop: true,
          linebreaks: true,
        });

        console.log(this.data);

        // render with data
        doc.render(this.data);

        // generate output
        const out = doc.getZip().generate({
          type: "blob",
          mimeType: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        });

        saveAs(out, this.name);
      } catch (error) {
        console.log(JSON.stringify({ error }, this.replaceErrors));

        if (error.properties && Array.isArray(error.properties.errors)) {
          const errorMessages = error.properties.errors.map((err) => err.properties.explanation).join("\n");
          console.error("Docxtemplater error:", errorMessages);
        }

        throw error;
      }
    },
  },
};
</script>
